import React, { useEffect, useState, useRef } from 'react';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import { useForm } from "react-hook-form";
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HttpHelper from '../../service/httpService'
import { CiEdit } from "react-icons/ci";
import { AiOutlineDelete } from "react-icons/ai";
import Loader from '../../Components/Loader';
import Accordion from 'react-bootstrap/Accordion';
import DashboardWrapper from './DashboardWrapper';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";

const SecurityObjectName = 'Website.Service';

const DashboardService = (props) => {

    const {
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,
        Outdent,
        OrderedList,
        UnorderedList,
        Undo,
        Redo,
        FontSize,FontName,
        FormatBlock,
        Link,
        Unlink,
        ViewHtml,
        InsertTable,
        AddRowBefore,
        AddRowAfter,
        AddColumnBefore,
        AddColumnAfter,
        DeleteRow,
        DeleteColumn,
        DeleteTable,
        MergeCells,
        SplitCell,
    } = EditorTools;

    const editor = useRef();
    const [contentData, setContentData] = useState("");
    const getHtml = () => {
        const view = editor.current.view;
        setValue("content", EditorUtils.getHtml(view.state))
    };

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const formRef = useRef();
    const [services, setServices] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const [serviceId, setserviceId] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [bannerImage, setBannerImage] = useState(null);
    const [imageCurrentShow, setImageCurrentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);
    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');

    const [serviceIdUpdate, setserviceIdUpdate] = useState('');
    const [rowVersion, setRowVersion] = useState('');
    const [fileId, setFileId] = useState('');
    const [fileDetails, setFileDetails] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');

    const [originalLocationImage, setOriginalLocationImage] = useState(null);

    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (isEditing === true) {
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("Location/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        serviceUpdate(data, serviceId, data.FileId)
                        delete data.file;
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else {
                serviceUpdate(data, serviceId)
            }
        } else {
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("Location/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        serviceAdd(data)
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else {
                serviceAdd(data)
            }
        }
    };

    const serviceAdd = async (data) => {
        delete data.serviceId
        await HttpHelper.post("Service", data).then((response) => {
            props.showToast('success', 'Service Added Succesfully');
            setLoaderApi(false);
            setPopupAddEdit(false);
            GetServiceList();
        }).catch((error) => {
            setLoaderApi(false);
            console.log(error);
        })
    }

    const serviceUpdate = async (data, id, imageId) => {
        if (imageId === undefined) {
            Object.assign(data,
                { rowVersion: rowVersion },
                { ServiceId: serviceIdUpdate },
                { FileId: fileId }
            );
            delete data.file;
        } else {
            Object.assign(data,
                { rowVersion: rowVersion },
                { FactId: serviceIdUpdate },
                { FileId: imageId }
            );
            delete data.file;
        }
        console.log(data)

        await HttpHelper.put("Service", data).then((response) => {
            props.showToast('success', 'Service Added Succesfully');
            setLoaderApi(false);
            setPopupAddEdit(false);
            GetServiceList();
            blankFormData()
        }).catch((error) => {
            setLoaderApi(false);
            console.log(error);
        })
    }

    const deleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("Location/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    const GetServiceList = async () => {
        setLoaderApi(true);
        await HttpHelper.get("Service").then((response) => {
            if (response.status == 200) {
                setServices(response.data.data);
                getAllPermission();
                setIsEditing(true);
                setLoaderApi(false);
            } else {
                console.info(response.data.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    const setServiceById = async (serviceId) => {

        setPopupAddEdit(true);
        setLoaderApi(true);

        setIsEditing(true);
        setShowLoader(true);

        setValue('title', '');
        setValue('description', '');
        setBannerImage('');
        setValue("serviceId", '');
        setOriginalLocationImage('');
        setserviceId('');
        setPrimaryKeyEncrypted('');
        setBannerImage('');

        await HttpHelper.get("Service/" + serviceId).then((response) => {
            if (response.status === 200) {
                setserviceIdUpdate(response.data.serviceId);
                setRowVersion(response.data.rowVersion)
                setFileId(response.data.fileId);
                if (response.data.file) {
                    setFileDetails(response.data.file);
                }

                console.log(response.data);
                setValue('title', response.data.title);
                setValue('description', response.data.description);
                if (response.data.file) {
                    setBannerImage(response.data.file.fileUrl);
                } else {
                    setBannerImage(null);
                }
                setContentData(response.data.description);
                setValue("serviceId", response.data.serviceId);
                setOriginalLocationImage(response.data.image);
                setserviceId(response.data.serviceId);
                setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted);
                accordianStatusHandle('1')
            }
            setShowLoader(false);
            setPopupAddEdit(true);
            setLoaderApi(false);
        }).catch((error) => {
            setShowLoader(false)
            console.log(error);
        })
    }

    const deleteService = async (serviceId, fileId) => {
        swal("Are you sure, you want to delete this service?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    await HttpHelper.delete("Service/" + serviceId).then((response) => {
                        if (response.status === 200) {
                            GetServiceList();
                        }
                        if (fileId) {
                            deleteUploadedFile(fileId)
                        }
                        props.showToast('success', 'Service Deleted successfully');
                    }).catch((error) => {
                        console.log(error);
                    })
                }
            });
    }

    const blankFormData = () => {
        setIsEditing(false)
        setValue('file', '');
        setValue('title', '');
        setValue('description', '');
        const view = editor.current.view;
        if (view) {
            EditorUtils.setHtml(view, '');
        }
    }

    const accordianStatusHandle = (elem) => {

        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }

    useEffect(() => {
        GetServiceList();
    }, []);

    return (
        <DashboardWrapper>
            <ToastContainer />
            <div className="DashboardWrapperChild">
                <Sidebar />
                <div className="contentWrapper">
                    <HeaderDashboard title="Services" />
                    <div className="container-fluid mt-80 p-0">
                        <div className="row">
                            {hasAddPermissionUser == true ? <div className="col-auto">
                                {isEditing === true ? <button onClick={() => {
                                    setPopupAddEdit(true);
                                    blankFormData();
                                    accordianStatusHandle('1');
                                }} className="btn btnSave">Add Service</button> : ''}
                            </div> : ''}
                            <div className="col-md-12 mb-2">
                            </div>


                            {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 mb-2 table-responsive">
                                <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                    <table className="table tableCustomized table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    #
                                                </th>
                                                <th>
                                                    title
                                                </th>
                                                <th>
                                                    Image
                                                </th>
                                                <th>
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                //Sandeep: Service Grid.
                                                services.length > 0 ? services.map((service, index) => {
                                                    return (<tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{service.title}</td>
                                                        <td>
                                                            {service.file && service.file.fileUrl !== null ?
                                                                <>
                                                                    <b className="imageViewButton" onClick={() => {
                                                                        setShowImgPopup(true);
                                                                        setImageCurrentShow(service.file.fileUrl);
                                                                    }}>View Image</b>
                                                                </>
                                                                : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-image-fill" viewBox="0 0 16 16">
                                                                    <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                                                                    <path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z" />
                                                                </svg>}
                                                        </td>
                                                        <td>
                                                            {hasEditPermissionUser == true ? <CiEdit onClick={() => { setServiceById(service.serviceId) }} /> : ''}
                                                            {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => {
                                                                if (service.fileId !== 'undefined' || service.fileId !== null) {
                                                                    deleteService(service.serviceId, service.fileId)
                                                                } else {
                                                                    deleteService(service.serviceId)
                                                                }
                                                            }} /> : ''}
                                                        </td>
                                                    </tr>)
                                                })
                                                    : <tr><td colSpan="5">No data found!!!</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="2">
                                            <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </div>}

                            <Accordion className="d-none" defaultActiveKey="0" activeKey={accordianStatus} ref={AccordianHandle}>
                                {hasReadPermissionUser == true ? <Accordion.Item eventKey="0" onClick={() => {
                                    accordianStatusHandle();
                                }}>
                                    <Accordion.Header>Service Grid</Accordion.Header>
                                    <Accordion.Body onClick={(e) => {
                                        e.stopPropagation();
                                    }}>
                                        <div className="col-md-12 mb-2">
                                            <div className="cardBox cardTableWrapperDashboard">
                                                <div className="row">
                                                    <table className="table tableCustomized table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    #
                                                                </th>
                                                                <th>
                                                                    title
                                                                </th>
                                                                <th>
                                                                    Image
                                                                </th>
                                                                <th>
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                services.length > 0 ? services.map((service, index) => {
                                                                    return (<tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{service.title}</td>
                                                                        <td>
                                                                            {service.file && service.file.fileUrl !== null ?
                                                                                <>
                                                                                    <b className="imageViewButton" onClick={() => {
                                                                                        setShowImgPopup(true);
                                                                                        setImageCurrentShow(service.file.fileUrl);
                                                                                    }}>View Image</b>
                                                                                </>
                                                                                : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-image-fill" viewBox="0 0 16 16">
                                                                                    <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                                                                                    <path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z" />
                                                                                </svg>}
                                                                        </td>
                                                                        <td>
                                                                            {hasEditPermissionUser == true ? <CiEdit onClick={() => { setServiceById(service.serviceId) }} /> : ''}
                                                                            {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => {
                                                                                if (service.fileId !== 'undefined' || service.fileId !== null) {
                                                                                    deleteService(service.serviceId, service.fileId)
                                                                                } else {
                                                                                    deleteService(service.serviceId)
                                                                                }
                                                                            }} /> : ''}
                                                                        </td>
                                                                    </tr>)
                                                                })
                                                                    : <tr><td colSpan="5">No data found!!!</td></tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item> : ''}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                <div className="crossPopup" onClick={() => {
                    setShowImgPopup(false);
                    setImageCurrentShow('');
                }}>
                    <RxCross1 />
                </div>
                <img src={imageCurrentShow} />
            </div>
            {hasAddPermissionUser || hasEditPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                <div className="popupEditAndAddForm">
                    <div className="popupEditAndAddFormCloseButton" onClick={() => {
                        setPopupAddEdit(false);
                        setIsEditing(true);
                    }} >
                        <RxCross2 />
                    </div>

                    {loaderApi == true ? <div className="loaderApi">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                            <g fill="none" fill-rule="evenodd">
                                <g transform="translate(1 1)" stroke-width="2">
                                    <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                    <path d="M36 18c0-9.94-8.06-18-18-18">
                                        <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                    </path>
                                </g>
                            </g>
                        </svg>
                    </div>
                        :
                        <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                            <div className="cardBox">
                                <h4>{isEditing === true ? "Update Service" : "Add Service"}</h4>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>File : {isEditing === true ? <span class="requiredAstric"> *</span> : ''}</label>
                                        <input type="file"  {...register('file', { required: isEditing === true ? false : true })} className="border mb-2 w-100 is-invalid" onChange={() => {
                                        }} />
                                        {errors.file?.type === 'required' && <p className="text-danger" role="alert">Image is required</p>}
                                        {isEditing === true ?
                                            bannerImage !== null ? <>
                                                <b className="imageViewButton" onClick={() => {
                                                    setShowImgPopup(true);
                                                    setImageCurrentShow(bannerImage);
                                                }}>View Image</b>
                                            </> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-image-fill" viewBox="0 0 16 16">
                                                <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                                                <path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z" />
                                            </svg>
                                            : null}
                                    </div>
                                    <div className="col-md-6">
                                        <label>Title : <span class="requiredAstric"> *</span></label>
                                        <input type="text"  {...register("title", { required: true })} className="border mb-2" placeholder="title" aria-invalid={errors.title ? "true" : "false"} />
                                        {errors.title?.type === 'required' && <p className="text-danger" role="alert">title is required</p>}
                                    </div>
                                    <div className="col-md-12">
                                        <label>Description : <span class="requiredAstric"> *</span></label>
                                        <Editor className="border" {...register("description", { required: true })} placeholder="description" aria-invalid={errors.description ? "true" : "false"}
                                            tools={[
                                                [Bold, Italic, Underline, Strikethrough],
                                                [Subscript, Superscript],
                                                [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                [Indent, Outdent],
                                                [OrderedList, UnorderedList],
                                                FontSize,FontName,
                                                FormatBlock,
                                                [Undo, Redo],
                                                [Link, Unlink, ViewHtml],
                                                [InsertTable],
                                                [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                                [DeleteRow, DeleteColumn, DeleteTable],
                                                [MergeCells, SplitCell],
                                            ]}
                                            ref={editor}
                                            defaultContent={contentData}
                                            onChange={(e) => {
                                                setValue('description', e.html);
                                            }}
                                        />
                                        {errors.description?.type === 'required' && <p className="text-danger" role="alert">description is required</p>}
                                    </div>
                                    {
                                        isEditing === true ?
                                            <input type="hidden" {...register('serviceId')} />
                                            : null
                                    }
                                    <div className="col-md-12 d-flex justify-content-end mt-3">
                                        <div>
                                            <button className="btn btnSave mt-2" onClick={getHtml}>Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>}

                </div>
            </div> : ''}
        </DashboardWrapper>
    )
}

export default DashboardService;